import { render, staticRenderFns } from "./reinit.vue?vue&type=template&id=606163cb&"
import script from "./reinit.vue?vue&type=script&lang=ts&"
export * from "./reinit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports